import React from 'react';
import { getCurrencyWithSymbol } from '../../../../page-builder/utils/formatPrice';
import { ReduxSelectorProps } from '../../../services/constants';

export interface CartTotalProps extends ReduxSelectorProps {
  className?: string;
  style?: {
    [key: string]: string;
  };
}

export const CartTotal: React.FC<CartTotalProps> = ({
  useAppSelector,
  className,
  style,
}) => {
  const cartData = useAppSelector(state => state.cart.cartData);
  return (
    <>
      <div className={`flex items-center ${className}`} style={style}>
        {getCurrencyWithSymbol(
          cartData?.currencyCode || 'USD',
          String(cartData?.TotalAmount),
        )}
      </div>
    </>
  );
};
